import React, {Component} from 'react'
import {Provider, connect } from 'react-redux'
import ReduxStore from '../reducers'
const store = ReduxStore()

import  OrderTotalSummary from '../containers/order_total_summary'

export default class CheckoutOrderTotal  extends Component {
  constructor(props){
    super(props);
    store.dispatch({type: "LOAD_TOTALS", initialState: this.props });
  }

  render(){
    return (
      <Provider store={store}>
        <OrderTotalSummary />
      </Provider>
    );
  }
}
